import React from "react";
import { Helmet } from "react-helmet";

class Seo extends React.Component {
  state = {
    title: null,
    desc: null,
    canonical: null,
  };

  componentDidMount() {
    this.setState({
      ...this.state,
      title: this.title(),
      desc: this.desc(),
      canonical: this.canonical(),
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        ...this.state,
        title: this.title(),
        desc: this.desc(),
        canonical: this.canonical(),
      });
    }
  }

  title = () => {
    return this.props.title || "Cycle Planner";
  };

  desc = () => {
    return (
      this.props.desc ||
      "Plan your bike journey and see breakdowns by most direct, quietest, and more balanced routes."
    );
  };

  canonical = () => {
    const loc = window.location;
    return this.props.canonical || loc.origin + loc.pathname.replace(/\/$/, "");
  };

  isStaging = () => {
    return window.location.hostname.includes("staging");
  };

  render() {
    return (
      <Helmet titleTemplate="%s | Better by Bike">
        <title>{this.state.title}</title>
        <meta name="description" content={this.state.desc} />
        <link rel="canonical" href={this.state.canonical} />
        {this.isStaging() && <meta name="robots" content="noindex, nofollow" />}
      </Helmet>
    );
  }
}

export default Seo;



// WEBPACK FOOTER //
// ./src/components/Seo.js